import React, { useCallback, useMemo, useState } from "react";
import { ChildrenProps } from "../Models/componentModel";
import {

    AgentDetails,
    AgentStatusResponse,
    CommonResponseSecondaryModel,
    ProfileAgentDetailsResponse,
} from "../Models/axiosModel";
import agent from "../service/api";

const AgentContext = React.createContext<AgentContextPayload | undefined>(undefined);

export interface AgentContextPayload {
    agentDetails: AgentDetails[];
    setAgentDetails: React.Dispatch<React.SetStateAction<AgentDetails[]>>;
    getAgentDetails: () => Promise<CommonResponseSecondaryModel<ProfileAgentDetailsResponse[]>>

    agentGlobalDetails: ProfileAgentDetailsResponse[];
    setAgentGlobalDetails: React.Dispatch<React.SetStateAction<ProfileAgentDetailsResponse[]>>;

    agentGlobalDetailsForTable: AgentDetails[];
    setAgentGlobalDetailsForTable: React.Dispatch<React.SetStateAction<AgentDetails[]>>;

    agentStatusDetails: AgentStatusResponse[];
    setAgentStatusDetails: React.Dispatch<React.SetStateAction<AgentStatusResponse[]>>;
    getAgentStatusDetails: () => Promise<CommonResponseSecondaryModel<AgentStatusResponse[]>>

    agentStatusStoredCurrentName: string | null;
    setAgentStatusStoredCurrentName: React.Dispatch<React.SetStateAction<string | null>>;

    removeAgentId: any;
    setRemoveAgentId: React.Dispatch<React.SetStateAction<any>>;

    agentFormDetails: any;
    setagentFormDetails: any;

    flagOpenAgentDetailsDialog: boolean;
    setFlagOpenAgentDetailsDialog: React.Dispatch<React.SetStateAction<boolean>>;

    isEditMode: boolean;
    setIsEditMode: React.Dispatch<React.SetStateAction<boolean>>;

    // agentRegister: Promise<any>
}


const AgentProvider = ({ children }: ChildrenProps) => {

    const [agentDetails, setAgentDetails] = useState<AgentDetails[]>([])
    const [agentGlobalDetails, setAgentGlobalDetails] = useState<ProfileAgentDetailsResponse[]>([])
    const [agentGlobalDetailsForTable, setAgentGlobalDetailsForTable] = useState<AgentDetails[]>([])
    const [agentStatusDetails, setAgentStatusDetails] = useState<AgentStatusResponse[]>([])
    const [agentStatusStoredCurrentName, setAgentStatusStoredCurrentName] = useState<string | null>(null)
    const [removeAgentId, setRemoveAgentId] = useState<any>({
        user_id: null
    })
    const [agentFormDetails, setagentFormDetails] = useState<any>({
        first_name: "",
        last_name: "",
        email_address: "",
        contact_number: "",
        re_captcha: "",
    })
    const [flagOpenAgentDetailsDialog, setFlagOpenAgentDetailsDialog] = useState<boolean>(false)
    const [isEditMode, setIsEditMode] = useState<boolean>(false)

    const getAgentDetails = useCallback(async () => {
        const response = await agent.getAgentDetailsAPI.get();
        return response;
    }, []);

    const getAgentStatusDetails = useCallback(async () => {
        const response = await agent.getAgentStatusDetailsAPI.get();
        return response;
    }, []);


    const payload: AgentContextPayload = useMemo(() => ({
        agentDetails,
        setAgentDetails,
        getAgentDetails,

        agentGlobalDetails,
        setAgentGlobalDetails,

        agentGlobalDetailsForTable,
        setAgentGlobalDetailsForTable,

        agentStatusDetails,
        setAgentStatusDetails,
        getAgentStatusDetails,

        agentStatusStoredCurrentName,
        setAgentStatusStoredCurrentName,

        removeAgentId,
        setRemoveAgentId,

        agentFormDetails,
        setagentFormDetails,

        flagOpenAgentDetailsDialog,
        setFlagOpenAgentDetailsDialog,

        isEditMode,
        setIsEditMode,

        // agentRegister
    }), [
        agentDetails,
        setAgentDetails,
        getAgentDetails,

        agentGlobalDetails,
        setAgentGlobalDetails,

        agentGlobalDetailsForTable,
        setAgentGlobalDetailsForTable,

        agentStatusDetails,
        setAgentStatusDetails,
        getAgentStatusDetails,

        agentStatusStoredCurrentName,
        setAgentStatusStoredCurrentName,

        removeAgentId,
        setRemoveAgentId,

        agentFormDetails,
        setagentFormDetails,

        flagOpenAgentDetailsDialog,
        setFlagOpenAgentDetailsDialog,

        isEditMode,
        setIsEditMode,
    ]);

    return (
        <AgentContext.Provider value={payload}>{children}</AgentContext.Provider>
    );
};

export { AgentContext, AgentProvider };
